const { getElement } = window.BAO.Utils

class LayoutSwitcher extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.passthroughParams = new URLSearchParams(window.location.search)

    const params = new URLSearchParams(window.location.search)

    if (params.get('layout')) {
      this.setLayout(params.get('layout'))
    }
  }

  setupListeners () {
    super.setupListeners()

    this.els.button.elements.forEach(btn => {
      this.listeners.add(btn, 'click', e => {
        this.handleLayoutButtonClick(e)
      })
    })
  }

  /**
   * @param {MouseEvent} e
   * @returns {void}
   */
  handleLayoutButtonClick (e) {
    const target = e.target.closest('[data-layout-switcher]')
    const layout = target.getAttribute('data-layout-switcher')
    this.setLayout(layout)
  }

  /**
   * @param {string} layout
   * @returns {void}
   * @public
   * */
  setLayout (layout) {
    this.els.button.elements.forEach(btn => {
      const btnLayout = btn.getAttribute('data-layout-switcher')
      btnLayout === layout
        ? btn.setAttribute('aria-pressed', 'true')
        : btn.setAttribute('aria-pressed', 'false')
    })
    this.itemList.setAttribute('data-layout', layout)
    this.modifyParams(layout)
  }

  /**
   * @param {string} layout
   * @returns {void}
   * @public
   * */
  modifyParams (layout) {
    const params = new URLSearchParams(window.location.search)
    this.passthroughParams.forEach((v, k) => {
      if (!params.has(k)) params.set(k, v)
    })
    params.set('layout', layout)
    window.history.replaceState(
      {},
      '',
      `${window.location.origin}${window.location.pathname}?${params}`,
    )
  }

  get itemList () {
    return getElement('[data-product-grid-container]')
  }
}

if (!customElements.get('layout-switcher')) {
  customElements.define('layout-switcher', LayoutSwitcher)
}
